import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PrintSheetContainer } from './PrintSheet'
import { ImageContainer } from '../Image'
import { Rectangle } from '../../../../../helpers/math'
import {
    Margin,
    PRINT_AREA_ID,
} from '../../../../../helpers/print'
import './print.css'

export class PrintPreview extends Component {

    static propTypes = {
        determinePrintOrientation: PropTypes.func.isRequired,
        previewSheet: PropTypes.object.isRequired,
        printOrientationAngle: PropTypes.number.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.state = {
            printArea: null,
        }

        this.margin = new Margin()
    }

    setPrintAreaRef = (node) => {
        if(this.state.printArea !== null) return

        this.setState({ printArea: node })
    }

    componentDidMount()
    {
        this.props.determinePrintOrientation()
    }

    render() {
        const { previewSheet, printOrientationAngle, id } = this.props

        let preview = null
        let print = null

        if(this.state.printArea)
        {
            let printFrame = Rectangle.createFromElement(this.state.printArea).rotate(printOrientationAngle)
            const forcedScale = previewSheet.width / printFrame.width
            printFrame = this.margin.apply(printFrame)

            preview = <PrintSheetContainer
                id={id}
                sheet={previewSheet}
                margin={this.margin.scale(forcedScale)}
                frame={printFrame.scale(forcedScale)}
                forcedScale={forcedScale}
            />
            print = <ImageContainer id={"print"} frame={printFrame} />
        }

        return (
            <div style={{ width: '100%', margin: 'auto' }}>
                <div
                    className="print-hidden"
                    id="previewArea"
                >
                    {preview}
                </div>
                <div
                    className="print-visible"
                    ref={this.setPrintAreaRef}
                    id={PRINT_AREA_ID}
                >
                    {print}
                </div>
            </div>
        )
    }
}
